import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import {makeStyles} from '@material-ui/core/styles'
import {
    Box,
    CssBaseline,
    Drawer,
    Button,
    IconButton,
    InputBase,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemSecondaryAction,
    Typography,
    Fade,
    Slide,
} from '@material-ui/core'
import TablePagination from '@material-ui/core/TablePagination'
import Close from '@material-ui/icons/Close'
import FolderIcon from '@material-ui/icons/Folder'
import EditIcon from '@material-ui/icons/Edit'
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined'
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder'

import {connect} from 'react-redux'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import {dataActions} from '../../../actions'

import DepartmentDrawer from './Departments/DepartmentDrawer'

const drawerWidth = '23rem'

// using hook API
const useStyles = makeStyles(theme => ({
    root: {
        display: '-webkit-flexbox',
        maxHeight: '93vh',
        overflowX: 'hidden',
        backgroundColor: '#F4F8F8',
    },
    iconButtonOpen: {
        height: '3rem',
        width: '2.0rem',
        minWidth: '1.5rem',
        position: 'fixed',
        top: '90px',
        left: '-4px',
        backgroundColor: theme.palette.green.medium,
        '&:hover': {
            backgroundColor: theme.palette.green.light,
        },
    },
    iconButton: {
        padding: 10,
        backgroundColor: '#F4F8F8',
        '&:hover': {
            opacity: '0.8',
            backgroundColor: '#F4F8F8',
        },
        transition: theme.transitions.create(['transform'], {
            duration: theme.transitions.duration.shortest,
        }),
    },
    drawer: {
        width: drawerWidth,
    },
    drawerPaper: {
        display: '-webkit-box',
        width: drawerWidth,
        position: 'relative',
        border: 'none',
        backgroundColor: '#F4F8F8',
    },
    unselected: {
        borderLeft: '5px solid transparent',
    },
    selected: {
        borderLeft: '5px solid #02AB77',
    },
    drawerOpen: {
        transform: 'rotate(180deg)',
    },
    editCategory: {
        position: 'relative',
        zIndex: 100,
        left: '10px',
    },
    viewArchiveButton: {
        marginLeft: '12px',
        fontSize: '0.8rem',
        color: '#707070',
        '&:hover': {
            color: theme.palette.green.medium,
            backgroundColor: 'transparent',
        },
    },
    searchBox: {
        display: '-webkit-flexbox',
        flexWrap: 'wrap',
        alignItems: 'center',
        border: '1px solid',
        borderColor: theme.palette.grey.medium,
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        margin: '8px 25px 0 32px',
        paddingRight: '5px',
    },
    searchInput: {
        margin: theme.spacing(1),
        flex: 1,
        width: '80%',
        [theme.breakpoints.down('sm')]: {
            width: '75%',
        },
    },
    clearButton: {
        padding: 10,
        color: theme.palette.grey.medium,
    },
}))

const Departments = props => {
    const classes = useStyles()
    const {
        token,
        roles,
        superadmin,
        setDepartment,
        departmentsdata,
        activedepartment,
        fetchingDepartments,
        departmentsDataRequest,
        open,
        handleDrawerOpen,
        handleDrawerClose,
    } = props

    // Display list of departments for Department Admins and Super Admins
    const deptadmindepartments =
        'admin' in roles
            ? departmentsdata.filter(
                  item => roles.admin.indexOf(item.deptId) > -1
              )
            : []
    const departmentsToDisplay = superadmin
        ? departmentsdata
        : deptadmindepartments

    const [openDialog, setOpenDialog] = useState(false)
    const [title, setTitle] = useState(' ')
    const [status, setStatus] = useState('A')
    const [searchTerm, setSearchTerm] = useState('')
    const [searchResults, setSearchResults] = useState(departmentsToDisplay)

    /* Pagination variables -- start */
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const departmentCount = departmentsToDisplay.length

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }
    /* Pagination variables -- end */

    const handleChange = e => {
        setSearchTerm(e.target.value)
    }

    const handleClearSearch = () => {
        setSearchTerm('')
    }

    const inactiveDeptExists = departmentsToDisplay
        ? departmentsToDisplay.filter(dept => dept.status === 'I')
        : []

    useEffect(() => {
        const results = departmentsToDisplay.filter(
            dept =>
                dept.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
                dept.status === status
        )
        results.sort((a, b) => (a.name > b.name ? 1 : -1))
        setSearchResults(results)
        setPage(0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [departmentsdata, searchTerm, status])

    let buttoncomponent

    const handleClickOpen = title => {
        setOpenDialog(true)
        setTitle(title)
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
    }

    const handleToggleStatus = status => {
        setStatus(status)
    }

    useEffect(() => {
        departmentsDataRequest(token)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    switch (status) {
        case 'A':
            buttoncomponent = inactiveDeptExists.length > 0 && (
                <Button
                    variant="text"
                    aria-label="view inactive departments"
                    onClick={() => handleToggleStatus('I')}
                    size="large"
                    className={classes.viewArchiveButton}
                >
                    View Inactive Departments
                </Button>
            )
            break
        case 'I':
            buttoncomponent = (
                <Button
                    variant="text"
                    aria-label="view active departments"
                    onClick={() => handleToggleStatus('A')}
                    size="large"
                    className={classes.viewArchiveButton}
                >
                    View Active Departments
                </Button>
            )
            break
        default:
            buttoncomponent = <div>Invalid option</div>
    }

    return (
        <>
            <CssBaseline />
            <div className={classes.root}>
                {!open && (
                    <Fade in={true} mountOnEnter unmountOnExit timeout={400}>
                        <Button
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => handleDrawerOpen()}
                            edge="start"
                            className={classes.iconButtonOpen}
                        >
                            <ChevronRightIcon
                                style={{color: '#FFFFFF', fontSize: '2.5rem'}}
                            />
                        </Button>
                    </Fade>
                )}
                <Slide direction="right" in={open} mountOnEnter unmountOnExit>
                    <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor="left"
                        open={open}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            style={{padding: '7% 0 0 0'}}
                            width="23rem"
                        >
                            <Box>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    flexDirection="row"
                                    justifyContent="space-between"
                                    style={{paddingLeft: '32px'}}
                                >
                                    <Typography
                                        variant="h5"
                                        style={{color: '#000000'}}
                                    >
                                        {status === 'A'
                                            ? 'Active Departments'
                                            : 'Inactive Departments'}
                                    </Typography>
                                    <IconButton
                                        className={clsx(
                                            classes.iconButton,
                                            !open && classes.drawerOpen
                                        )}
                                        onClick={() => handleDrawerClose()}
                                    >
                                        <ChevronLeftIcon
                                            style={{fontSize: '2.5rem'}}
                                        />
                                    </IconButton>
                                </Box>

                                {departmentCount > 10 && (
                                    <Box className={classes.searchBox}>
                                        <InputBase
                                            className={classes.searchInput}
                                            placeholder="Search"
                                            inputProps={{
                                                'aria-label': 'search events',
                                            }}
                                            value={searchTerm}
                                            onChange={handleChange}
                                        />
                                        {searchTerm && (
                                            <IconButton
                                                className={classes.clearButton}
                                                onClick={() =>
                                                    handleClearSearch()
                                                }
                                            >
                                                <Close />
                                            </IconButton>
                                        )}
                                    </Box>
                                )}
                                {departmentCount > 10 ? (
                                    <Box>
                                        <TablePagination
                                            labelRowsPerPage={
                                                'Showing results for'
                                            }
                                            rowsPerPageOptions={[10]}
                                            component="div"
                                            count={searchResults.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={handleChangePage}
                                            onChangeRowsPerPage={
                                                handleChangeRowsPerPage
                                            }
                                        />
                                    </Box>
                                ) : null}
                                {departmentCount > 0 ? (
                                    <>
                                        <List>
                                            {searchResults
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage +
                                                        rowsPerPage
                                                )
                                                .map(department => (
                                                    <ListItem
                                                        button
                                                        className={
                                                            activedepartment.deptId ===
                                                            department.deptId
                                                                ? classes.selected
                                                                : classes.unselected
                                                        }
                                                        key={department.deptId}
                                                        disabled={
                                                            fetchingDepartments
                                                        }
                                                        selected={
                                                            activedepartment.deptId ===
                                                            department.deptId
                                                        }
                                                        autoFocus={
                                                            activedepartment.deptId ===
                                                            department.deptId
                                                        }
                                                        onClick={() =>
                                                            setDepartment(
                                                                activedepartment.deptId ===
                                                                    department.deptId
                                                                    ? {}
                                                                    : {
                                                                          token,
                                                                          department,
                                                                      }
                                                            )
                                                        }
                                                    >
                                                        <ListItemIcon>
                                                            {activedepartment.deptId ===
                                                            department.deptId ? (
                                                                <FolderIcon
                                                                    style={{
                                                                        marginLeft:
                                                                            '15px',
                                                                        color:
                                                                            '#098447',
                                                                    }}
                                                                />
                                                            ) : (
                                                                <FolderOutlinedIcon
                                                                    style={{
                                                                        marginLeft:
                                                                            '15px',
                                                                        opacity: 0.8,
                                                                    }}
                                                                />
                                                            )}
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                department.name
                                                            }
                                                            primaryTypographyProps={{
                                                                variant:
                                                                    'body1',
                                                                style: {
                                                                    fontWeight:
                                                                        activedepartment.deptId ===
                                                                        department.deptId
                                                                            ? '700'
                                                                            : '400',
                                                                },
                                                            }}
                                                        />
                                                        {activedepartment.deptId ===
                                                            department.deptId && (
                                                            <ListItemSecondaryAction>
                                                                <ListItemIcon>
                                                                    <IconButton
                                                                        className={
                                                                            classes.editCategory
                                                                        }
                                                                        onClick={() =>
                                                                            handleClickOpen(
                                                                                'Edit Department'
                                                                            )
                                                                        }
                                                                    >
                                                                        <EditIcon
                                                                            style={{
                                                                                color:
                                                                                    '#098447',
                                                                            }}
                                                                        />
                                                                    </IconButton>
                                                                </ListItemIcon>
                                                            </ListItemSecondaryAction>
                                                        )}
                                                    </ListItem>
                                                ))}
                                            <ListItem>
                                                {buttoncomponent}
                                            </ListItem>
                                        </List>
                                    </>
                                ) : (
                                    <Typography
                                        variant="body1"
                                        style={{
                                            padding: '20px 32px',
                                            color: '#000000',
                                        }}
                                    >
                                        We couldn’t find any departments
                                        assigned to you. Check with your Unit
                                        Administrator to make sure you’ve been
                                        added as a Unit Admin to the event
                                        category you’re seeking. Or use the
                                        CREATE DEPARTMENT button to add new
                                        departments.
                                    </Typography>
                                )}
                            </Box>
                            <Box
                                style={{
                                    alignSelf: 'center',
                                    margin: '0 0 15px 0',
                                    width: '300px',
                                }}
                            >
                                {superadmin ? (
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        aria-label="create new department"
                                        onClick={() =>
                                            handleClickOpen('Create Department')
                                        }
                                        //edge="start"
                                        size="large"
                                        startIcon={
                                            <CreateNewFolderIcon
                                                style={{color: '#098447'}}
                                            />
                                        }
                                        style={{width: '100%'}}
                                    >
                                        Create Department
                                    </Button>
                                ) : null}
                            </Box>
                        </Box>
                    </Drawer>
                </Slide>

                <DepartmentDrawer
                    title={title}
                    openDialog={openDialog}
                    handleCloseDialog={handleCloseDialog}
                    handleToggleStatus={handleToggleStatus}
                />
            </div>
        </>
    )
}

Departments.propTypes = {
    token: PropTypes.string.isRequired,
    open: PropTypes.bool,
    handleDrawerOpen: PropTypes.func.isRequired,
    handleDrawerClose: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        roles: state.authentication.roles,
        superadmin: state.authentication.admin,
        fetchingDepartments: state.departmentsdata.fetchingDepartments,
        activedepartment: state.departmentsdata.manageroledept,
        defaultdepartment: state.authentication.departmentslist[0],
        departmentsdata: state.departmentsdata.departmentslist,
    }
}

const mapDispatchToProps = {
    setDepartment: payload => dataActions.manageroledeptSetRequest(payload),
    departmentsDataRequest: token => dataActions.departmentsDataRequest(token),
}

export default connect(mapStateToProps, mapDispatchToProps)(Departments)
